import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import SelectSingleTag from 'Components/Organisms/SelectSingleTag/SelectSingleTag';

export default function RHFSelectSingleTag({ name, ...other }) {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <SelectSingleTag {...field} error={error?.message} {...other} />
            )}
        />
    );
}

RHFSelectSingleTag.propTypes = {
    name: PropTypes.string.isRequired,
};
